import useGetSearchCustomers from "@/pages/dashboard/customer/hooks/useGetSearchCustomers";
import { Alert, Center, Stack, Text, TextInput } from "@mantine/core";
import { useDebouncedValue, useFocusTrap } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IconSearch, IconX } from "@tabler/icons-react";
import SearchSkeleton from "../searchSkeleton";
import SearchUserItem from "../searchUserItem";
import { NoResult } from "@/components/noResult";
import { Customer } from "@/models/response/customer";

type Props = {
  selectedUsers: Customer[];
  close: () => void;
  setSelectedUsers: Dispatch<SetStateAction<Customer[]>>;
};

function SearchUsers({ close, setSelectedUsers, selectedUsers }: Props) {
  const focusTrapRef = useFocusTrap();
  const [search, setSearch] = useState("");
  const [value, setValue] = useState("");

  const [debounced] = useDebouncedValue(search, 300);

  const { data, isLoading, refetch } = useGetSearchCustomers({
    params: {
      Count: 100,
      Skip: 0,
      Term: debounced,
    },
  });

  useEffect(() => {
    if (debounced) refetch();
  }, [debounced, refetch]);

  const addCustomer = (customer: Customer) => {
    return () => {
      const find = selectedUsers.find((x) => x.id === customer?.id);
      if (find) {
        notifications.show({
          message: "کاریر قبلا اضافه شده است",
          color: "red",
        });
        return;
      }
      setSelectedUsers((prev) => [...prev, customer]);
      notifications.show({
        message: "کاربر با موفقیت اضافه شد",
        color: "green",
      });
      close();
    };
  };

  // const handleSearchChange = (e: string) => {
  //   if (e.length >= 3) {
  //     setSearch(e);
  //   } else if (e.length === 0) {
  //     setSearch("");
  //   }
  // };

  useEffect(() => {
    if (value.length >= 3) {
      setSearch(value);
    } else {
      setSearch("");
    }
  }, [value]);

  return (
    <Stack>
      <Alert variant="info">
        <Text size="xs">نام یا شماره تلفن را برای جستجو اعضا وارد نمایید</Text>
      </Alert>
      <TextInput
        size="md"
        value={value}
        onChange={(event) => setValue(event.currentTarget.value)}
        ref={focusTrapRef}
        leftSection={<IconSearch />}
        rightSection={
          search && (
            <IconX size="15px" color="gray" onClick={() => setSearch("")} />
          )
        }
      />

      {!isLoading && value && value?.length < 2 && (
        <Text size="xs" p="0" c="yellow">
          وارد کردن حداقل 2 کاراکتر برای جستجو الزامی می باشد
        </Text>
      )}
      {isLoading ? (
        <Stack>
          <SearchSkeleton />
          <SearchSkeleton />
        </Stack>
      ) : (
        data?.result?.map((customer) => (
          <SearchUserItem
            customer={customer}
            addCustomer={addCustomer(customer)}
          />
        ))
      )}
      {!isLoading && data?.result?.length === 0 && debounced && (
        <Center>
          <NoResult />
        </Center>
      )}
    </Stack>
  );
}

export default SearchUsers;
